import {createBrowserHistory} from 'history';

const history = createBrowserHistory({
  basename: '/app',
});

export default history;
